export const appTesimonial = [
    {
        image: "assets/img/testimonials/1.jpg",
        title: "Senior softwar Maketing Manager",
        name: "Moris Wonders",
        discription: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Tempore reiciendis nisi quod commodi dolor fugiat. ipsum dolor sit amet consectetur adipisicing Possimus ea quis illo accusantium?"
    },
    {
        image: "assets/img/testimonials/2.jpg",
        title: "Senior softwar Maketing Manager",
        name: "Dominika smith",
        discription: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Tempore reiciendis nisi quod commodi dolor fugiat. ipsum dolor sit amet consectetur adipisicing Possimus ea quis illo accusantium?"
    },
    {
        image: "assets/img/testimonials/3.jpg",
        title: "Senior softwar Maketing Manager",
        name: "Dreco Jois",
        discription: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Tempore reiciendis nisi quod commodi dolor fugiat. ipsum dolor sit amet consectetur adipisicing Possimus ea quis illo accusantium?"
    },

] 